import Form from './Form';
import Message from './Message';
import UploadImage from './UploadImage';
import EditBgColor from './EditBgColor';
import NavigationBar from './NavigationBar';
import LeavingMessage from './LeavingMessage';
import Contact from './Contact';
import FormBuilder from './FormBuilder';
import Slider from './Slider';


// Vue
import AboutUs from './pages/AboutUs';
import AdminMetaTags from "./pages/AdminMetaTags";

let App = {
    init() {
        window.Form = new Form();
        $('body').removeClass('loading');
        window.Message = new Message();
        window.Contact = new Contact();
        window.Slider = new Slider();

        if(document.getElementById('about-us-app')){
            AboutUs.init();
        }
        if(document.getElementById('admin-lenders-edit')){
            AdminMetaTags.init();
        }

    }
};

/**
 * Begin app gracefully
 */
// Create app window
function startApp() {
    if (!window.appStarted) {
        window.App = App;
        window.App.init();
        window.appStarted = true;
    }
}
// Start app on window load or 2s after the DOM is ready
$(window).on('load', () => {
    startApp();
});
$(document).on('ready', () => {
    setTimeout( () => {
        startApp();
    }, 2000);

    // Display back to top icon on bottom right
    if($(document).height() > 1500) {
        $('.back-to-top-container').css("display", "block");
    } else {
        $('.back-to-top-container').css("display", "none");
    }


    // const select = document.getElementById('location-select');
    // if(select) {
    //     select.addEventListener('change', () => {
    //         window.location.href =
    //             location.protocol + '//' +
    //             window.location.host +
    //             window.location.pathname +
    //             '?location=' + select.value;
    //     });
    // }

    // Lax init
    // window.onload = function() {
    //     lax.setup();
    //
    //     const updateLax = () => {
    //         lax.update(window.scrollY)
    //         window.requestAnimationFrame(updateLax)
    //     }
    //
    //     window.requestAnimationFrame(updateLax)
    // }
    // window.addEventListener("resize", function() {
    //     lax.updateElements()
    // });

    // Flushes content to footer of column
    $('.column-footer').parent().attr('style','margin-top: auto !important');

    $('a.lightbox').featherlight({
        targetAttr: 'href'
    });




});




// WEBPACK FOOTER //
// ./resources/assets/js/App.js